import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M15.5 5H11l5 7-5 7h4.5l5-7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.5 5H4l5 7-5 7h4.5l5-7z"
})), 'DoubleArrowTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/DoubleArrowTwoTone.js
// module id = 3262
// module chunks = 2